import { useEffect } from "react";
import { useAppSelector } from "../../stateManagement/hooks/redux";
import { getItemWebStorage } from "../../features/webStorageSaver";
import { useGetWeatherStationsByCustomerCodeQuery, WeatherStation } from "../../api/rtk/weatherStations/slices/weatherStationsApiSlice";

export function useWeatherStations(): { weatherStations?: [WeatherStation], isFetching: boolean, isError: boolean } {
    const currentConfig = getItemWebStorage('currentConfig');
    const workspace = currentConfig?.workspace;
    const hardCustomerCode = currentConfig?.services?.weatherStations?.code;

    const token = useAppSelector(state => state.auth.tokens.services?.weatherStations)

    const { data: weatherStations, isFetching, refetch, isError } =
        useGetWeatherStationsByCustomerCodeQuery(
            { customerCode: hardCustomerCode ?? workspace },
            { skip: !token }
        )

    useEffect(() => {
        if (token) refetch();
    }, [token, refetch])

    return { weatherStations, isFetching, isError };
}